//angular
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
//app components
import { DialogChangePaymentRuntimeComponent } from '../dialog-charge-payment-runtime/dialog-charge-payment-runtime.component';
//app data
import { KeyName } from 'src/app/app.keynames';
import { DateFormatValues, GridColumnsSection, OpacityState, PaymentRunStatus } from 'src/app/app.data';
//app models & Interfaces
import { CompanyTimezone, InvoiceObject, RestResponse, PaymentRunOperation } from 'src/app/_shared/models';
import { POST_PaymentRunOperationInterface } from 'src/app/_shared/interfaces/advanced-settings-operations.interface';

//app services
import { DataSharingService, GridService, LoaderService, SkeletonLoaderService, UtilsService } from 'src/app/_core/services';
//others
import { interval, Subscription } from 'rxjs';
import * as dayjs from 'dayjs';
import * as duration from 'dayjs/plugin/duration';
dayjs.extend(duration)
import * as relativeTime from 'dayjs/plugin/relativeTime';
import { SettingsService } from '../../../_services/api/settings.service';
import { HttpParamsInterface } from 'src/app/_shared/interfaces/http-params.interface';
import { MetaService } from 'src/app/_core/services/meta.service';
import { DialogConfirmationComponent } from 'src/app/modules/main/_shared/dialog/confirmation/confirmation.component';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
dayjs.extend(relativeTime)

@Component({
  providers: [GridService],
  selector: 'app-grid-payment-run',
  templateUrl: './grid-payment-run.component.html'
})
export class GridPaymentRunComponent implements OnInit, OnDestroy {
  clockDaysToDday: string;
  clockMinutesToDday: number;
  clockHoursToDday: number;
  clockSecondsToDday: number;
  collectionOfPaymentRunPending: Array<PaymentRunOperation> = [];
  companyTimezone: CompanyTimezone;
  dialogConfirmation: MatDialogRef<DialogConfirmationComponent>;
  dialogChangePaymentRunTime: MatDialogRef<DialogChangePaymentRuntimeComponent>;
  gridBulkSection: boolean = false;
  gridColumnsParam: string = GridColumnsSection.invoices;
  gridFilter: boolean = false;
  gridPanelPreferences: boolean = false;
  gridSearch: boolean = false;
  gridSectionMessage: boolean = false;
  subscriptionToCountdown: Subscription;
  subscriptionToTimezone: Subscription;
  private subs = new Unsubscriber();
  timezoneOffset: any;
  @Input() _dateFormatValues = DateFormatValues;
  @Input() _paymentRunStatus = PaymentRunStatus;

  @Output() emitGetPaymentRunHistory: EventEmitter<any> = new EventEmitter<any>();
  countdownTime: any = null;

  constructor(
    private _dialog: MatDialog,
    private _iconRegistry: MatIconRegistry,
    private _loader: LoaderService,
    private _sanitizer: DomSanitizer,
    private _shareData: DataSharingService,
    public _grid: GridService,
    public _meta: MetaService,
    public _skeleton: SkeletonLoaderService,
    private settingsService: SettingsService,
    private utilService: UtilsService
  ) {
    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this._iconRegistry.addSvgIcon("ico-run", this._sanitizer.bypassSecurityTrustResourceUrl("assets/svg/ico-rocket-01.svg"));
    this._iconRegistry.addSvgIcon("ico-schedule",this._sanitizer.bypassSecurityTrustResourceUrl("assets/svg/ico-subscriptions-01.svg"));

    this._grid.itemsPerPage = 10;
    this._grid.orderBy = 'createdAt';
    this._grid.sortBy = 'DESC';
  }

  getPaymentRunByPendingStatus() {
    const httpParams: HttpParamsInterface = {
      orderBy: this._grid.orderBy,
      sortBy: this._grid.sortBy,
    }

    this.settingsService.getPaymentOperations(httpParams, true).subscribe(
      (res: RestResponse) => {
        this._grid.currentPageNumber = res.currentPageNumber;
        this._grid.itemsPerPage = res.itemsPerPage;
        this._grid.totalItems = res.totalItems;
        this._grid.totalPages = 1;
        this._grid.collectionOfGridItems = <Array<InvoiceObject>>(res.data);

        this._skeleton.skeletonGridLoader = true;
        this._skeleton.skeletonGridDataLoader = true;

        if (this._grid.collectionOfGridItems.length > 0) {
          this.collectionOfPaymentRunPending = this._grid.collectionOfGridItems.filter(billingItem => billingItem.status === PaymentRunStatus.pending);
          this._grid.statusGrid = OpacityState.isVisible;
          this._grid.statusGridMessage = OpacityState.isHidden;
        } else {
          this._grid.statusGrid = OpacityState.isHidden;
          this._grid.statusGridMessage = OpacityState.isVisible;
        }
      },
      (err: RestResponse) => {
        this._meta.showNotification(err);
      }
    )
  }

  ngOnDestroy() {
    this._grid.clearData();
    this._skeleton.skeletonGridLoader = false;
    this._skeleton.skeletonGridDataLoader = false;
    this.subscriptionToCountdown.unsubscribe();
    this.subscriptionToTimezone.unsubscribe();
  }

  async ngOnInit() {
    const {companySettingsTimezone, displayDateFormat} = this._shareData.getDateConfig();
    this.timezoneOffset = companySettingsTimezone.offSet;

    try {
      let _isSubscribedToCompanyTimezone = await this.subscribeToCompanyTimezone();
      if (_isSubscribedToCompanyTimezone){
          this.subscriptionToCountdown = interval(1000).subscribe(
            {
              next: () => {
                if (this.collectionOfPaymentRunPending.length > 0){
                  this.setCountdown(dayjs(this.collectionOfPaymentRunPending[0].targetDate).utcOffset(this.timezoneOffset));
                }
              },
              error: () => {
                console.log('@@@err line 132 billing-operations.component.ts')
              }
            }
          )
      }
    } catch (error) {
      console.log('@@@error',error);
    }
  }

  setCountdown (_dDay) {
    // const counterHoursInADay = 24;
    // const counterMilliSecondsInASecond = 1000;
    // const counterMinutesInAnHour = 60;
    // const counterSecondsInAMinute  = 60;
    // const millisecond = dayjs(_dDay).diff(dayjs(), 'millisecond');

    // this.clockHoursToDday = Math.floor((millisecond) / (counterMilliSecondsInASecond * counterMinutesInAnHour * counterSecondsInAMinute) % counterHoursInADay);
    // this.clockMinutesToDday = Math.floor((millisecond) / (counterMilliSecondsInASecond * counterMinutesInAnHour) % counterSecondsInAMinute);
    // this.clockSecondsToDday = Math.floor((millisecond) / (counterMilliSecondsInASecond) % counterSecondsInAMinute);
    const millisecond = dayjs(_dDay).diff(dayjs(), 'millisecond');
    this.countdownTime = this.utilService.dhm(millisecond);

    if (this.countdownTime && this.countdownTime.completed) {
      this.getPaymentRunByPendingStatus();
    }

  }

  showChangePaymentTargetDate(_index) {
    this.dialogChangePaymentRunTime = this._dialog.open(DialogChangePaymentRuntimeComponent, {
      panelClass: ['custom-mat-dialog'],
      data: {
        operationData: this.collectionOfPaymentRunPending[_index],
        operationToEdit: 'Payment Operation - Change Runtime'
      }
    });

    this.dialogChangePaymentRunTime.afterClosed().subscribe((res:any) => {
      if (res?.dateTime) {
        const bodyParams: POST_PaymentRunOperationInterface = {
          newDateTime: null
        }

        bodyParams.newDateTime = res.dateTime;

        this._loader.startPageLoader();

        this.settingsService.updateCompanyPaymentRunByPaymentRunId(this.collectionOfPaymentRunPending[_index].id, bodyParams).subscribe(
          (res: RestResponse) => {
            let billingOperations = new PaymentRunOperation().deserialize(res.data);
            this.collectionOfPaymentRunPending[_index].targetDate = billingOperations.targetDate;
            this._loader.stopPageLoader();
            this._meta.showNotification(res);
          },
          (err: RestResponse) => {
            this._loader.stopPageLoader();
            this._meta.showNotification(err);
          }
        );
      }
    });
  }

  showDialogRunPaymentNow(_index) {
    this.dialogConfirmation = this._dialog.open(DialogConfirmationComponent, {
      panelClass: ['custom-mat-dialog'],
      data: {
        keyName: KeyName.execute_payment_run_now,
        word_confirmation: 'Payment-run'
      },
    });
    this.dialogConfirmation.afterClosed().subscribe((resCode) => {
      if (resCode === KeyName.execute_payment_run_now) {
        const paymentRunId = this.collectionOfPaymentRunPending[_index].id;
        this.subs.addSub = this.settingsService.paymentRunExecuteNow(paymentRunId).subscribe(
          (res: RestResponse) => {
            setTimeout(() => {
              this.emitGetPaymentRunHistory.emit();
              this.getPaymentRunByPendingStatus()
              this._loader.stopPageLoader();
              this._meta.showNotification(res);
            }, 3000);
          },
          (err: RestResponse) => {
            this._loader.stopPageLoader();
            this._meta.showNotification(err);
          }
        );
      }
    });
  }

  subscribeToCompanyTimezone() {
    return new Promise((resolve, reject) => {
      this.subscriptionToTimezone = this._shareData.currentCompanySettingsTimezone.subscribe(
        (data) => {
          this.companyTimezone = new CompanyTimezone().deserialize(data);
          console.log('@@@this.companyTimezone',this.companyTimezone);
          resolve(true);
        },
        (err) => {
          console.log('@@err',err);
          reject(false);
        }
      );
    })
  }
}
